import { withRouter } from 'react-router';
import ChangePassword from './change-password';
import { ResetPasswordCallbackRouteProps } from '../reset-password-callback/reset-password-callback-container';

export type IProps = ResetPasswordCallbackRouteProps;

export default withRouter(ChangePassword);
